const modalAlertsState = {
    active: []
};
export default modalAlertsState;
